<template>
  <div class="c-question">
    <question-item v-for="q in data" :key="q.question_uuid" :data="q" />
  </div>
</template>

<script>
import QuestionItem from './question-item.vue';

export default {
  name: 'QuestionResource',
  components: {
    QuestionItem,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
